// Formulaires métier intelligents : sections repliables par métier / type de chantier.
export const TRADE_FORMS = {
  chauffagiste: [
    {
      key: "installation",
      title: "Identification de l'installation",
      fields: [
        { label: "Type d'installation", type: "select", options: ["Chauffage seul", "Chauffage + eau chaude", "Chaudière murale", "Chaudière au sol", "Boiler", "Pompe à chaleur", "Radiateurs", "Chauffage sol", "Autre"] },
        { label: "Combustible", type: "select", options: ["Gaz naturel", "Propane", "Mazout", "Électrique", "Autre"] },
        { label: "Condensation", type: "select", options: ["Condensation", "Non-condensation", "Inconnu"] },
        { label: "État de l'installation", type: "select", options: ["Bon", "Moyen", "Vétuste", "Hors service"] },
      ],
    },
    {
      key: "chaudiere",
      title: "Chaudière existante",
      fields: [
        { label: "Marque", type: "text" },
        { label: "Modèle", type: "text" },
        { label: "Puissance (kW)", type: "text" },
        { label: "Année approximative", type: "text" },
        { label: "Type de raccordement", type: "select", options: ["Cheminée tubée", "Ventouse horizontale", "Ventouse verticale", "Autre"] },
      ],
    },
    {
      key: "tubage",
      title: "Tubage / cheminée",
      fields: [
        { label: "Diamètre tubage (mm)", type: "text" },
        { label: "Longueur tubage (m)", type: "text" },
        { label: "Nombre de coudes", type: "text" },
        { label: "Type de conduit", type: "select", options: ["Flexible inox", "Rigide inox", "PP", "Autre"] },
        { label: "Ventilation du local", type: "select", options: ["Conforme", "À adapter", "À créer", "Inconnu"] },
      ],
    },
    {
      key: "raccordements",
      title: "Raccordements",
      fields: [
        { label: "Diamètre gaz", type: "text" },
        { label: "Diamètre chauffage", type: "text" },
        { label: "Eau froide", type: "text" },
        { label: "Eau chaude", type: "text" },
        { label: "Évacuation condensats", type: "select", options: ["Existante", "À créer", "Pompe de relevage nécessaire", "Inconnu"] },
      ],
    },
    {
      key: "ecs",
      title: "Eau chaude sanitaire",
      fields: [
        { label: "Type de production", type: "select", options: ["Instantanée", "Ballon", "Boiler électrique", "Aucune"] },
        { label: "Capacité (litres)", type: "text" },
        { label: "Emplacement", type: "text" },
        { label: "Dimensions disponibles", type: "text" },
      ],
    },
    {
      key: "pac",
      title: "Pompe à chaleur / climatisation",
      fields: [
        { label: "Type d'équipement", type: "select", options: ["Air/eau", "Air/air", "Mono-split", "Multi-split", "Géothermie", "Autre"] },
        { label: "Nombre d'unités intérieures", type: "text" },
        { label: "Emplacement unité extérieure", type: "text" },
        { label: "Longueur des liaisons (m)", type: "text" },
        { label: "Alimentation électrique", type: "select", options: ["Monophasé", "Triphasé", "À créer", "Inconnu"] },
        { label: "Accès chantier", type: "select", options: ["Facile", "Moyen", "Difficile"] },
      ],
    },
  ],
  electricien: [
    {
      key: "existant",
      title: "Installation existante",
      fields: [
        { label: "Type d'installation", type: "select", options: ["Monophasé", "Triphasé 230V", "Triphasé 400V", "Inconnu"] },
        { label: "Tension", type: "text" },
        { label: "Ancienneté approximative", type: "text" },
        { label: "État général", type: "select", options: ["Bon", "Moyen", "Vétuste", "Non conforme"] },
        { label: "Mise à la terre", type: "select", options: ["Présente et conforme", "Présente à vérifier", "Absente", "Inconnu"] },
      ],
    },
    {
      key: "tableau",
      title: "Tableau électrique",
      fields: [
        { label: "Nombre de modules", type: "text" },
        { label: "Nombre de disjoncteurs", type: "text" },
        { label: "Différentiels", type: "text" },
        { label: "Réserve disponible", type: "text" },
        { label: "Intervention", type: "select", options: ["Remplacement complet", "Remplacement partiel", "Mise en conformité", "Extension"] },
      ],
    },
    {
      key: "points",
      title: "Prises, interrupteurs, éclairage",
      fields: [
        { label: "Prises à installer", type: "text" },
        { label: "Interrupteurs à installer", type: "text" },
        { label: "Points lumineux", type: "text" },
        { label: "Type de pose", type: "select", options: ["Encastré", "Apparent", "Mixte"] },
        { label: "Commandes spéciales", type: "select", options: ["Aucune", "Variateur", "Détecteur", "Domotique", "Va-et-vient"] },
      ],
    },
    {
      key: "cablage",
      title: "Câblage",
      fields: [
        { label: "Type de câble", type: "text" },
        { label: "Section (mm²)", type: "text" },
        { label: "Longueur totale (m)", type: "text" },
        { label: "Cheminement", type: "select", options: ["Goulotte", "Tube encastré", "Faux plafond", "Vide technique", "Apparent"] },
        { label: "Percements / traversées", type: "text" },
      ],
    },
    {
      key: "equipements",
      title: "Équipements spécifiques",
      fields: [
        { label: "Équipement", type: "select", options: ["Aucun", "Borne de recharge", "Photovoltaïque", "Ventilation", "Chauffage électrique", "Pompe à chaleur", "Chauffe-eau", "Domotique", "Alarme", "Réseau", "Portail", "Vidéophone"] },
        { label: "Puissance nécessaire", type: "text" },
        { label: "Distance depuis le tableau (m)", type: "text" },
        { label: "Protection dédiée", type: "select", options: ["À prévoir", "Existante", "Inconnu"] },
      ],
    },
  ],
};

TRADE_FORMS.plombier = [TRADE_FORMS.chauffagiste[3], TRADE_FORMS.chauffagiste[4]];
TRADE_FORMS.climaticien = [TRADE_FORMS.chauffagiste[5], TRADE_FORMS.chauffagiste[3]];
TRADE_FORMS.ventilation = [TRADE_FORMS.chauffagiste[0], TRADE_FORMS.chauffagiste[3]];
TRADE_FORMS.autre = [TRADE_FORMS.chauffagiste[0]];
